import { Skeleton } from "@/components/atoms";
import { ContractPricingProfilesTable, useContractPricingProfilesContext } from "@/components/organisms";
import { PricingProfile } from "./PricingProfile";
import { PricingProfileAdd } from "./PricingProfileAdd";

export const ContractPricingProfiles = () => {
  const { isFetching } = useContractPricingProfilesContext();

  if (isFetching) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return <ContractPricingProfilesTable />;
};

ContractPricingProfiles.Add = PricingProfileAdd;
ContractPricingProfiles.PricingProfile = PricingProfile;
